import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignExecutionDto } from "../../../models/campaign/dto/campaign.dto";

export const GET_CAMPAIGN_EXECUTIONS_QUERY_KEY = (campaignId: string) => ['campaigns', campaignId, 'executions'];

export const useGetCampaignExecutions = (campaignId: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CAMPAIGN_EXECUTIONS_QUERY_KEY(campaignId),
        queryFn: () => client.fetchApi<CampaignExecutionDto[], {}>({
            endpoint: `campaigns/admin/${campaignId}/executions`,
            method: 'GET'
        }),
        staleTime: 30_000,
        enabled: !!campaignId,
    });
};
